import {ApolloError, ServerError} from '@apollo/client'
import {Dispatch} from 'redux'
import {navigateTo} from 'browserHistory'
import {notifyError} from 'store/actions/notify'
import {asyncError} from 'store/actions/asyncError'

export const handleQueryError = (error: ApolloError, dispatch: Dispatch) => {
  if (error.networkError) {
    if (shouldRedirectToInitialInput(error.networkError)) {
      navigateTo('/initial_input')
      return
    }

    dispatch(asyncError(error.networkError))
    return
  }

  if (error.graphQLErrors) {
    const message = error.graphQLErrors[0]?.message
    if (message) {
      dispatch(notifyError(message))
      return
    }
  }
}

export const isServerError = (error: Error): error is ServerError => error.name === 'ServerError'

const shouldRedirectToInitialInput = (error: Error) =>
  isServerError(error) && error.statusCode === 403 && (error.result as Record<string, unknown>)['_redirect_to_employee']
